<template>
  <ul
    v-if="showMenu && menuList.length > 0 && showHierarchy"
    class="menu-box"
    :style="{ '--theme-color': shopThemeColor }"
  >
    <div class="classification_box">
      <li
        v-for="(item, index) in menuList"
        :key="index"
        class="primary_classification"
      >
        <h2
          class="title_box"
          :title="item.name"
          @click="toListBtn(item)"
        >
          {{ item.name }}
        </h2>

        <div
          v-if="item.children && item.children.length > 0"
          class="secondary_classification"
        >
          <span
            v-for="(ele, ids) in item.children"
            :key="ids"
            class="secondary_classification_item"
            @click="toListBtn(ele)"
          >
            {{ ele.name }}
          </span>

          <div
            v-if="item.children && item.children.length > 0"
            class="suspension_box"
          >
            <template v-for="(ele, eleIndex) in item.children">
              <div
                v-if="ele.children && ele.children.length > 0"
                :key="eleIndex"
                class="suspension_box_item"
              >
                <h2
                  class="suspension_box_title"
                  @click="toListBtn(ele)"
                >
                  {{ ele.name }}
                </h2>

                <div class="three_classification">
                  <span
                    v-for="(talg, idx) in ele.children"
                    :key="idx"
                    class="three_classification_item"
                    @click="toListBtn(talg)"
                  >
                    {{ talg.name }}
                  </span>
                </div>
              </div>
            </template>
          </div>
        </div>
      </li>
    </div>
  </ul>
</template>

<script>
import Mixin from "@/components/mixin/common_mixin";

export default {
  name: 'classification',
  mixins: [Mixin],
  props: {
    // 数据源
    menuList: {
      type: Array,
      default: () => []
    },
    // 是否默认展示所有分类的一级菜单
    showMenu: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showHierarchy: true
    };
  },
  computed: {
    // 动态主题色
    shopThemeColor() {
      return this.systemEnvironment === 'trs' ? '#89b92a' : '#FD5425';
    }
  },
  methods: {
    toListBtn(data) {
      this.showHierarchy = false;
      setTimeout(() => {
        this.showHierarchy = true;
      }, 2000);
      this.$emit('toListBtn', data);
    }
  }
};
</script>

<style lang="less" scoped>
@import "src/assets/styles/shopping/common";

.menu-box {
  width: 280px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  position: relative;
  transition: all 0.5s ease;
  background-color: #fff;
  height: 460px;

  .classification_box {
    width: 100%;
    height: 460px;
    overflow: hidden;

    &:hover {
      overflow-y: auto;
    }
  }

  .primary_classification {
    width: 100%;
    padding: 10px 15px;
    border-bottom: 1px solid #eee;
    box-sizing: border-box;

    .title_box {
      color: #333;
      font-size: 15px;
      font-weight: bold;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-wrap: break-word;
      word-break: break-all;

      &:hover {
        cursor: pointer;
        color: var(--theme-color);
      }
    }

    .secondary_classification {
      display: flex;
      flex-wrap: wrap;
      width: 240px;

      .secondary_classification_item {
        color: #666;
        font-size: 14px;
        display: inline-block;
        padding: 10px 20px 10px 0;

        &:hover {
          cursor: pointer;
          font-weight: bold;
          color: var(--theme-color);
        }
      }
    }

    .suspension_box {
      display: none;
      width: 930px;
      height: 460px;
      position: absolute;
      background-color: #fff;
      top: 0;
      right: -920px;
      z-index: 1200;
      box-shadow: 0 0 18px 0 rgba(0, 0, 0, 0.1);
      padding: 0 20px 10px 20px;
      overflow-y: auto;
      align-items: center;

      .suspension_box_item {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;

        .suspension_box_title {
          color: #333;
          font-size: 15px;
          font-weight: bold;
          margin: 13px 15px 0 0;

          &:hover {
            cursor: pointer;
            font-weight: bold;
            color: var(--theme-color);
          }
        }

        .three_classification {
          display: flex;
          flex: 1;
          flex-wrap: wrap;

          .three_classification_item {
            color: #666;
            font-size: 15px;
            margin: 13px 15px 0 0;
            display: inline-block;

            &:hover {
              cursor: pointer;
              font-weight: bold;
              color: var(--theme-color);
            }
          }
        }
      }
    }

    &:hover {
      .suspension_box {
        display: block;
      }
    }
  }

  .primary_classification:last-child {
    border-bottom: none;
  }
}
</style>